/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * Five-way classification of a prescription's PA posture at write time.

Consumed by :class:`PrescriptionModel` to split a batch into sendable
vs. PA-gated prescriptions. See ``PRIOR_AUTH.md`` § "Decision logic"
for the source-of-truth description.
 */
export type PriorAuthGateOutcomeT =
  (typeof PriorAuthGateOutcomeT)[keyof typeof PriorAuthGateOutcomeT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriorAuthGateOutcomeT = {
  NO_COVERAGE: "NO_COVERAGE",
  NO_PA: "NO_PA",
  PA_REQUIRED: "PA_REQUIRED",
  EXCLUDED: "EXCLUDED",
  UNKNOWN: "UNKNOWN",
} as const;
